<div class="contactBanner">
  <div class="container">
    <div class="bannerContent">
      <div class="banner text-center mx-auto">
        <p>Contact Us</p>
        <img class="bannerImg img-fluid" src="assets/images/contactBanner.svg" alt="banner" />
      </div>
    </div>
  </div>
</div>
<div class="getInTouchSection" id="contact">
  <div class="container">
    <div class="row customPadding align-items-center">
      <div class="col-lg-7 col-md-12">
        <img src="assets/images/getInTouch.png" alt="getInTouch" class="img-fluid">
      </div>
      <div class="col-lg-5 col-md-12">
        <div class="getInTouch">
          <div class="formHeader">
            <h2>Get in Touch</h2>
            <p>If you're having problems switching online, have an enquiry or want to give us some feedback, you can get
              in touch with our team who will be happy to help.</p>
          </div>
          <form class="row g-3" name="contactForm" #cFormRef="ngForm" (ngSubmit)="submit(cFormRef)"
            [formGroup]="contactForm" novalidate autocomplete="off">
            <div class="name col-md-6">
              <mat-label>Name</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input matInput type="text" formControlName="name" required />
                <mat-error *ngIf="contactForm.get('name')!.hasError('required')">
                  Name is required
                </mat-error>
                <mat-error
                  *ngIf="!contactForm.get('name')!.hasError('required') && contactForm.get('name')!.hasError('invalidName')">
                  Please enter a valid Name
                </mat-error>
              </mat-form-field>
            </div>
            <div class="phone col-md-6">
              <mat-label>Phone Number</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input matInput type="tel" formControlName="phoneNumber" required />
                <mat-error *ngIf="contactForm.get('phoneNumber')!.hasError('required')">
                  Phone number is required
                </mat-error>
                <mat-error
                  *ngIf="!contactForm.get('phoneNumber')!.hasError('required') && contactForm.get('phoneNumber')!.hasError('invalidPhone')">
                  Please enter a valid Phone Number
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12 mt-0">
              <mat-label>Email</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input matInput type="text" formControlName="email" required />
                <mat-error *ngIf="contactForm.get('email')!.hasError('required')">
                  Email is required
                </mat-error>
                <mat-error
                  *ngIf="!contactForm.get('email')!.hasError('required') && contactForm.get('email')!.hasError('invalidEmail')">
                  Please enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12 mt-0">
              <mat-label>Message</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <textarea matInput type="text" formControlName="message" required></textarea>
                <mat-error *ngIf="contactForm.get('message')!.hasError('required')">
                  Message is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12 mt-0">
              <button mat-flat-button color="primary" fxShow="false" fxShow.gt-sm type="submit"
                [disabled]="contactForm!.invalid || disabled">
                <app-loader [type]="'btn'" *ngIf="disabled"></app-loader>
                Get in Touch
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>